import APIService from '../../services/api'

export const FETCH_EXHIBITION_GROUP_TYPE = 'FETCH_EXHIBITION_GROUP_TYPE'
export const GET_EXHIBITION_GROUP_TYPE = 'GET_EXHIBITION_GROUP_TYPE'
export const SET_EXHIBITION_GROUP_TYPE = 'SET_EXHIBITION_GROUP_TYPE'

export const FETCH_COUNTRIES = 'FETCH_COUNTRIES'
export const GET_COUNTRIES = 'GET_COUNTRIES'
export const SET_COUNTRIES = 'SET_COUNTRIES'

export const FETCH_EXHIBITION_GROUPS = 'FETCH_EXHIBITION_GROUPS'
export const GET_EXHIBITION_GROUPS = 'GET_EXHIBITION_GROUPS'
export const SET_EXHIBITION_GROUPS = 'SET_EXHIBITION_GROUPS'

const actions = {
  [GET_EXHIBITION_GROUP_TYPE] ({commit}) {
    commit(FETCH_EXHIBITION_GROUP_TYPE)
    APIService.getExhibitionGroupType({
      columns: 'id,typefr,typeen',
      transform: true,
      order: {
        column: 'typefr',
        direction: 'ASC'
      }
    })
      .then(json => {
        commit(SET_EXHIBITION_GROUP_TYPE, {
          results: json.visu_exhibition_group_type || [],
          total: json._results || 0
        })
      })
  },

  [GET_COUNTRIES] ({commit}) {
    commit(FETCH_COUNTRIES)
    APIService.getCountries({
      columns: 'id, namefr, nameen',
      transform: true,
      order: {
        column: 'namefr',
        direction: 'ASC'
      }
    })
      .then(json => {
        commit(SET_COUNTRIES, {
          results: json.visu_country || [],
          total: json._results || 0
        })
      })
  },

  [GET_EXHIBITION_GROUPS] ({commit}) {
    commit(FETCH_EXHIBITION_GROUPS)
    APIService.getExhibGroups({
      columns: 'id, titlefr, titleen',
      transform: true,
      order: {
        column: 'titlefr',
        direction: 'ASC'
      }
    })
      .then(json => {
        commit(SET_EXHIBITION_GROUPS, {
          results: json.visu_exhibition_group || [],
          total: json._results || 0
        })
      })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/glossary/actions.js